import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FolderTabInfos } from '@hub4b/models/folder-tab-infos';
import { Folder } from '@hub4b/models/server/folder';
import { ReminderNotification } from '@hub4b/models/server/reminderNotification';
import { ArchivedFoldersService } from '@hub4b/services/http/archived-folders.service';
import { FoldersService } from '@hub4b/services/http/folders.service';
import { ReminderNotificationsService } from '@hub4b/services/http/reminder-notifications.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ArchivedFolderDetailComponent } from './folder-detail/archived-folder-detail-component';
import { FolderDetailComponent } from './folder-detail/folder-detail.component';
import { ReminderNotificationComponent } from './notifications/reminder-notification/reminder-notification.component';

@Component({
    selector: 'app-folder-detail-container',
    templateUrl: './folder-detail-container.component.html',
    styleUrls: ['./folder-detail-container.component.scss'],
    imports: [FolderDetailComponent, ArchivedFolderDetailComponent, ReminderNotificationComponent, AsyncPipe, NgxSpinnerModule]
})
export class FolderDetailContainerComponent implements OnInit {
    /**
     * Dossier dont le détail est affiché.
     */
    public folder$: Observable<Folder>;

    /**
     * Valeur indiquant si le dossier est géré par bannette ou par workflow.
     */
    @Input()
    public folderTabInfos: FolderTabInfos;

    /**
     * Emis lorsque le dossier est fermé.
     */
    @Output()
    public closed: EventEmitter<boolean> = new EventEmitter();

    public reminderNotifications$: Observable<ReminderNotification[]>;

    /**
     * Constructeur.
     * @param foldersService
     */
    constructor(
        private foldersService: FoldersService,
        private archivedFoldersService: ArchivedFoldersService,
        private reminderNotificationsService: ReminderNotificationsService
    ) {}

    /**
     * Appelée à l'initialisation du composant.
     */
    ngOnInit(): void {
        if (this.folderTabInfos.view.isArchive) {
            this.folder$ = this.archivedFoldersService.get(this.folderTabInfos.view.id, this.folderTabInfos.folderId);
        } else {
            this.folder$ = this.foldersService.get(this.folderTabInfos.view.id, this.folderTabInfos.folderId);
        }

        this.reminderNotifications$ = this.reminderNotificationsService.GetFolderReminderNotifications(this.folderTabInfos.view.id, this.folderTabInfos.folderId);
    }

    public onReminderNotificationClose(reminderNotification) {
        this.reminderNotificationsService.update(this.folderTabInfos.view.id, this.folderTabInfos.folderId, reminderNotification).subscribe();
    }
}
